import { render, staticRenderFns } from "./DispensaSetorAdm.vue?vue&type=template&id=9bad36f6"
import script from "./DispensaSetorAdm.vue?vue&type=script&lang=js"
export * from "./DispensaSetorAdm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports